<template>
  <div style="height: 310px" ref="chart"></div>
</template>

<script>
export default {
  props: {
    position: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: 11111,
          name: "白领/一般职员",
          itemStyle: { color: "#0D81FF" },
        },
        {
          value: 22222,
          name: "金融从业者",
          itemStyle: { color: "#11CE99" },
        },
        {
          value: 33333,
          name: "老师",
          itemStyle: { color: "#FFB95E" },
        },
        {
          value: 444444,
          name: "学生",
          itemStyle: { color: "#49C568" },
        },
        {
          value: 55555,
          name: "公务员",
          itemStyle: { color: "#FE4D45" },
        },
        {
          value: 66666,
          name: "工人",
          itemStyle: { color: "#FF872F" },
        },
        {
          value: 77777,
          name: "农民",
          itemStyle: { color: "#FE8F8A" },
        },
        {
          value: 888888,
          name: "医务人员",
          itemStyle: { color: "#AEB3F1" },
        },
        {
          value: 99999,
          name: "未识别",
          itemStyle: { color: "#CCCCCC" },
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
        },
        legend: {
          type:"scroll",
          orient: "vertical",
          left: -5,
          top: 50,
          icon: "circle",
          data: [
            "白领/一般职员",
            "金融从业者",
            "老师",
            "学生",
            "公务员",
            "工人",
            "农民",
            "医务人员",
            "未识别",
          ],
          itemGap: 10,
          itemWidth: 8,
          itemHeight: 8,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: "性别",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: true,
          label: {
            // show: false,
            normal: {
                    show: false,
                },
                emphasis: {
                    show: false
                }
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss"></style>
